import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext } from 'react';
import QuestionGroupContext from '../../../contexts/QuestionGroupContext';

/**
 * Compact summary of a GRID question group for the structure pane
 */
const GridLayoutPreview: React.FC = () => {
  const { questionGroup } = useContext(QuestionGroupContext);

  const headers = questionGroup.table_headers || [];
  const rowCount = (questionGroup.questions || []).length;

  if (headers.length === 0) {
    return (
      <div className='utb-grid-summary utb-grid-summary--empty'>
        <FontAwesomeIcon icon='table' />
        <span>
          No grid configured yet. Use the grid icon above to add columns and
          rows.
        </span>
      </div>
    );
  }

  return (
    <div className='utb-grid-summary'>
      <div className='utb-grid-summary__cols'>
        {headers.map((header, i) => (
          <span key={i} className='utb-chip'>
            {header}
          </span>
        ))}
      </div>
      <span className='utb-grid-summary__meta'>
        {headers.length} columns · {rowCount} rows
      </span>
    </div>
  );
};

export default GridLayoutPreview;
